import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, ClipboardCheckIcon, CalendarIcon, RocketIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: 1,
    icon: MailIcon,
    title: 'You Contact Us',
    description: 'Reach out with your project details and requirements.'
  }, {
    number: 2,
    icon: ClipboardCheckIcon,
    title: 'We Evaluate Your Needs',
    description: 'We review your goals and provide tailored recommendations.'
  }, {
    number: 3,
    icon: CalendarIcon,
    title: 'Free 30-Minute Consultation',
    description: 'Book a free consultation to discuss your vision in detail.'
  }, {
    number: 4,
    icon: RocketIcon,
    title: 'Launch Your Site',
    description: 'You approve the design and we launch your website.'
  }];
  return <section className="py-section-xs md:py-section-md lg:py-section-lg bg-white dark:bg-[#1E1E1E] relative overflow-hidden" data-id="element-310">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-311">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-312">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold mb-4" data-id="element-313">
            How It Works
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-lg text-gray-600 dark:text-gray-300" data-id="element-314">
            Our simple 4-step process to get your website live
          </motion.p>
        </div>
        <div className="relative max-w-6xl mx-auto" data-id="element-315">
          {/* Golden Thread SVG */}
          <svg className="absolute top-0 left-0 w-full h-full pointer-events-none hidden lg:block" style={{
          zIndex: 0
        }} data-id="element-316">
            <motion.path d="M 12% 15% Q 30% 5%, 38% 15% Q 46% 25%, 62% 15% Q 70% 5%, 88% 15%" stroke="url(#goldGradient)" strokeWidth="3" fill="none" strokeLinecap="round" initial={{
            pathLength: 0,
            opacity: 0
          }} whileInView={{
            pathLength: 1,
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 2,
            ease: 'easeInOut',
            delay: 0.5
          }} data-id="element-317" />
            <defs data-id="element-318">
              <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-319">
                <stop offset="0%" stopColor="#FFD700" stopOpacity="0.8" data-id="element-320" />
                <stop offset="25%" stopColor="#FDB931" stopOpacity="1" data-id="element-321" />
                <stop offset="50%" stopColor="#FFD700" stopOpacity="1" data-id="element-322" />
                <stop offset="75%" stopColor="#FDB931" stopOpacity="1" data-id="element-323" />
                <stop offset="100%" stopColor="#FFD700" stopOpacity="0.8" data-id="element-324" />
              </linearGradient>
            </defs>
          </svg>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative z-10" data-id="element-325">
            {steps.map((step, index) => <motion.div key={step.number} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1 + 0.3
          }} className="bg-[#212C34] rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 relative" data-id="element-326">
                <motion.div initial={{
              scale: 0,
              rotate: -180
            }} whileInView={{
              scale: 1,
              rotate: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: index * 0.1 + 0.5,
              type: 'spring',
              stiffness: 200
            }} className="absolute -top-4 left-6 w-12 h-12 rounded-full bg-gradient-to-br from-yellow-400 via-yellow-500 to-yellow-600 flex items-center justify-center shadow-lg ring-4 ring-yellow-400/30" data-id="element-327">
                  <span className="text-white font-bold text-xl" data-id="element-328">
                    {step.number}
                  </span>
                  <motion.div className="absolute inset-0 rounded-full bg-gradient-to-br from-yellow-300 to-yellow-500" animate={{
                scale: [1, 1.2, 1],
                opacity: [0.5, 0.2, 0.5]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-329" />
                </motion.div>
                <div className="mt-6 mb-4" data-id="element-330">
                  <div className="w-12 h-12 bg-[#0DC3DC]/30 rounded-lg flex items-center justify-center border border-[#0DC3DC]/40" data-id="element-331">
                    <step.icon size={32} className="text-[#0DC3DC]" data-id="element-332" />
                  </div>
                </div>
                <h3 className="text-xl font-bold mb-2 text-white" data-id="element-333">
                  {step.title}
                </h3>
                <p className="text-white/90 leading-relaxed" data-id="element-334">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}